<div class="relative  z-50 bg-white bg-opacity-90  w-full h-full border border-gray-200">
    <div class="absolute top-[50%] left-[50%] transform -translate-x-1/2 ">
        <section class="dots-container">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
        </section>

    </div>
</div>